module.exports = __webpack_public_path__ + "img/W-35.5beb42d1.jpg";